import { render, staticRenderFns } from "./remCom.vue?vue&type=template&id=071d4c0e&scoped=true"
import script from "./remCom.vue?vue&type=script&lang=js"
export * from "./remCom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/rem.css?vue&type=style&index=0&id=071d4c0e&prod&scoped=true&lang=css&external"
import style1 from "./remCom.vue?vue&type=style&index=1&id=071d4c0e&prod&scoped=true&lang=css"
import style2 from "./remCom.vue?vue&type=style&index=2&id=071d4c0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d4c0e",
  null
  
)

export default component.exports